export enum ERROR_TYPE_ENUM{
    clientSideError = 'clientSideError',
    serverError = 'serverError'
}